if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          /*
            OMAD'S 2026-09-09 : recherche par CLASSE et non par identifiant. L'identifiant
            est desormais prefixe par `localPosition` dans `country-localization.liquid`,
            parce que deux selecteurs de pays coexistent sur la page depuis le selecteur
            combine du header, et qu'un `id` en double est invalide.
          */
          liveRegion: this.querySelector('.sr-country-search-results, #sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.body.classList.remove('omads-localisation-ouverte');
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      /*
        OMAD'S 2026-09-09 : le formulaire et le champ se resolvent depuis l'element CLIQUE,
        et non plus par le PREMIER `querySelector` de tout le composant.

        Pourquoi. Le selecteur combine du header (`snippets/localization-combinee.liquid`)
        place DEUX formulaires dans un meme panneau, celui des langues et celui des pays.
        Avec l'ancien code, un clic sur un pays ecrivait le code pays dans le champ
        `locale_code` du premier formulaire, puis soumettait ce premier formulaire :
        Shopify recevait une langue invalide, et **rien ne le signalait**.

        Retrocompatible : quand le composant n'a qu'un formulaire et qu'un champ, ce qui
        est le cas des 4 autres rendus (pied de page, barre d'annonce x2, header en mode
        langue seule), `closest('form')` renvoie ce meme formulaire et la recherche du
        champ y trouve le meme champ. Le repli sur `this.elements.input` couvre le cas ou
        l'item ne serait pas dans un formulaire.
      */
      onItemClick(event) {
        event.preventDefault();
        const item = event.currentTarget;
        const form = item.closest('form') || this.querySelector('form');
        const champ =
          (form && form.querySelector('input[name="locale_code"], input[name="country_code"]')) ||
          this.elements.input;
        if (!champ || !form) return;
        champ.value = item.dataset.value;
        form.submit();
      }

      openSelector() {
        /*
          OMAD'S 2026-09-09 : cette classe sur `<body>` permet de lever la section du
          header au-dessus des elements collants de la page pendant que le panneau est
          ouvert. Le panneau vit DANS `.section-header`, qui est `position: sticky` avec
          `z-index: 4` : son propre `z-index` ne peut donc pas le faire passer devant
          `.ph-sticky` (le CTA collant des fiches produit, `z-index: 999`), parce que
          c'est le contexte d'empilement du parent qui plafonne. Mesure du 09/09 : le CTA
          recouvrait le bas du panneau sur telephone.
        */
        document.body.classList.add('omads-localisation-ouverte');
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        /*
          OMAD'S 2026-09-09 : la recherche ne parcourt que les liens de la LISTE DES PAYS.
          Avant, elle parcourait tous les `<a>` du composant et lisait `.country` sur
          chacun. Dans le selecteur combine du header, les liens de langue n'ont pas de
          `.country` : `item.querySelector('.country').textContent` levait une exception
          des la premiere lettre tapee, et le filtre mourait. Les liens de pays vivent
          tous dans `.country-selector__list`, dans le rendu combine comme dans l'ancien,
          donc ce cadrage ne change rien aux 4 autres rendus.
        */
        const allCountries = this.querySelectorAll('.country-selector__list a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
